import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Plug, CheckCircle2, AlertCircle } from "lucide-react";

export default function IntegracionesIndicator() {
  const [estado, setEstado] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/integraciones/estado");
      setEstado(data);
    } catch (e) {
      /* noop */
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);

  if (!estado || estado.pendientes === 0) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid="integraciones-indicator"
          className="hidden sm:inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[11px] font-medium text-amber-700 hover:bg-amber-100 transition-colors"
          title="Integraciones pendientes de conectar"
        >
          <Plug className="h-3.5 w-3.5" />
          {estado.pendientes} integración(es) pendiente(s)
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-3" data-testid="integraciones-popover">
        <p className="text-sm font-semibold text-slate-900 mb-1">Estado de integraciones</p>
        <p className="text-[12px] text-slate-500 mb-3">
          El sistema funciona y se puede demostrar sin estas conexiones. Quedan pendientes de cargar credenciales.
        </p>
        <div className="space-y-2">
          {estado.items.map((it) => (
            <div key={it.clave} className="flex items-start gap-2" data-testid={`integracion-${it.clave}`}>
              {it.conectado ? (
                <CheckCircle2 className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" />
              ) : (
                <AlertCircle className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" />
              )}
              <div className="min-w-0">
                <p className="text-[13px] font-medium text-slate-800 leading-tight">{it.label}</p>
                <p className="text-[11px] text-slate-500">{it.detalle}</p>
                {!it.conectado && it.pendiente_de && (
                  <p className="text-[11px] text-amber-700 mt-0.5">{it.pendiente_de}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
